import React from 'react';
import TextFieldForElements from '../TextFieldForElements';

class ElementsPositionY extends React.Component {
  render() {
    const { shouldUpdateWithDiff } = this.props;
    return (
      <TextFieldForElements
        property="y"
        formattedMessage="properties.position.y"
        shouldUpdateWithDiff={shouldUpdateWithDiff}
      />
    );
  }
}

export default ElementsPositionY;
